// 后台response check
export const backResCheck = (response) => {
  if (response.code === 0) {
    return true
  } else {
    return false
  }
}
